import { render, staticRenderFns } from "./ProjectLayoutAside.vue?vue&type=template&id=f6af2f2e&scoped=true&"
import script from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLayoutAside.vue?vue&type=style&index=0&id=f6af2f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af2f2e",
  null
  
)

export default component.exports